import React from "react";
import { MessageCircle } from "lucide-react";
import { whatsappLink } from "../../lib/site";

export const FinalCta = () => {
  return (
    <section id="agendar" data-testid="final-cta-section" className="relative py-24 sm:py-28 lg:py-36 bg-[#0A2540] text-white overflow-hidden">
      <div
        className="absolute inset-0 opacity-[0.08] pointer-events-none"
        style={{
          backgroundImage:
            "radial-gradient(circle at 20% 20%, #D4AF37 0%, transparent 35%), radial-gradient(circle at 80% 80%, #0D3B66 0%, transparent 45%)",
        }}
        aria-hidden
      />
      <div className="relative max-w-4xl mx-auto px-6 sm:px-8 text-center">
        <p className="overline text-[#D4AF37] mb-6">Próximo passo</p>
        <h2 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight">
          Você não precisa conviver{" "}
          <span className="italic text-[#D4AF37]">com a dor</span>.
        </h2>
        <p className="mt-8 text-white/75 text-lg max-w-2xl mx-auto leading-relaxed">
          Agende sua avaliação e descubra as possibilidades de tratamento mais
          adequadas para o seu caso — com acolhimento, técnica e foco em
          qualidade de vida.
        </p>

        <a
          data-testid="final-cta-whatsapp"
          href={whatsappLink()}
          target="_blank"
          rel="noopener noreferrer"
          className="mt-12 inline-flex items-center justify-center gap-3 bg-[#25D366] hover:bg-[#20BD5A] text-white text-lg font-semibold px-10 py-5 rounded-sm shadow-2xl transition-transform hover:-translate-y-1"
        >
          <MessageCircle className="w-6 h-6" />
          Agendar pelo WhatsApp
        </a>

        <p className="mt-6 text-xs text-white/50">
          Atendimento rápido • Resposta em horário comercial
        </p>
      </div>
    </section>
  );
};
